<template>
  <transition
    v-if="canAccessPage"
    name="slide-fade"
    mode="out-in">
    <router-view></router-view>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AnoFiscal',
  methods: {
    accessForbidden() {
      this.$router.push({ name: 'inicio' });
      this.$toast(this.$t('message.acesso_negado'));
    },
  },
  computed: {
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canAccessPage() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'ANO_FISCAL').length;
    },
  },
  beforeMount() {
    if (!this.canAccessPage) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};
</script>
